import { AfterViewInit, Component, Input, TemplateRef, ViewChild, inject } from '@angular/core';
import { OffcanvasService } from '../../../../_services/offcanvas-service/offcanvas.service';
import { NgTemplateOutlet } from '@angular/common';
import { HttpParams } from '@angular/common/http';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-offcanvas-base',
  imports: [NgTemplateOutlet, NgbTooltip],
  templateUrl: './offcanvas-base.component.html',
})
export class OffcanvasBaseComponent implements AfterViewInit {
  protected offcanvasService = inject(OffcanvasService);

  @ViewChild('routerOutlet') routerOutlet!: TemplateRef<HTMLTemplateElement>;
  @Input() returnUrl: string | undefined;
  @Input() returnParams: HttpParams | undefined;
  @Input() closeBtnDisabled: boolean = false;

  public ngAfterViewInit(): void {
    this.offcanvasService.close();
    this.offcanvasService.open(this.routerOutlet);
  }

  close() {
    this.offcanvasService.close(this.returnUrl, this.returnParams);
  }
}
